    // src/redux/slices/authSlice.js
    import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
    import axios from "axios";
    import { ApiBaseUrl, deleteAccountClient } from "../../Utils/Constants";
    import { showToast } from "../../Helper/Toast";

    export const hitDeleteAccountClientApi = createAsyncThunk("hitDeleteAccountClientApi", async () => {
      try {
        const config = {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: `${localStorage.getItem("clientToken")}`,
          },
        };
        const url = ApiBaseUrl + deleteAccountClient;
        const response = await axios.put(url, {}, config);
        return response.data;
      } catch (error) {
        showToast(error.response.data.message, "error");
        throw error.response.data;
      }
    });
    
    const DeleteAccountClientSlice = createSlice({
      name: "deleteAccountClientReducer",
      initialState: {
        isLoading: false,
        data: null,
      },
      reducers: {
        clearhitDeleteAccountClientData: (state) => {
          state.data = null;
        },
      },
      extraReducers: (builder) => {
        builder
          .addCase(hitDeleteAccountClientApi.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(hitDeleteAccountClientApi.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
          })
          .addCase(hitDeleteAccountClientApi.rejected, (state) => {
            state.isError = false;
          });
      },
    });

    export const { clearhitDeleteAccountClientData } = DeleteAccountClientSlice.actions;
    export default DeleteAccountClientSlice.reducer;
    